import { useState } from 'react';
import { FaCopy, FaStar, FaCheck } from 'react-icons/fa';
import { Bars } from 'react-loader-spinner'
import copy from 'copy-to-clipboard';


const Gift = () => {
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const [showCopiedErrorMessage, setShowCopiedErrorMessage] = useState(false);
  const [loadingIban, setLoadingIban] = useState(false);


  const bankAccounts = [
    {
      bank: 'Bizum',
      name: 'A Dani o a Raquel',
      bankCode: '',
      number: '',
      favorite: true,
      isBank: false
    },
    {
      bank: 'N26 (Alemania)',
      bankCode: 'n26',
      name: 'Daniel García González',
      number: 'DE79 **** **** **** 8229',
      favorite: true,
      isBank: true
    },
    {
      bank: 'ING',
      bankCode: 'ing',
      name: 'Daniel García González o Raquel Huete Campos',
      number: 'ES08 **** **** **** 7670',
      favorite: true,
      isBank: true
    }
  ];

  const copyToClipboard = async (bankCode) => {
    try {
      setLoadingIban(true)
      const response = await fetch(`https://api.daniraquel.love/bank/${bankCode}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      setLoadingIban(false)
      const data = await response.json();
      const bankAccount = data?.responseObject?.bank;
      copy(bankAccount, { message: 'IBAN N26: Puedes copiarlo seleccionando el texto' })
      setShowCopiedMessage(true);
      setTimeout(() => setShowCopiedMessage(false), 4000);
    } catch (error) {
      setLoadingIban(false)
      setShowCopiedErrorMessage(true);
      setTimeout(() => setShowCopiedErrorMessage(false), 15000);
      console.error('Error fetching bank account:', error);
    }
  };

  return (
    <section className="py-16 px-4 bg-white relative">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-6">Sobre Digital</h2>

        <p className="text-center text-gray-600 mb-8">
          Para quienes quieran mandarnos una muestra de cariño
        </p>

        <div className="space-y-6">
          {bankAccounts.map((account, index) => (
            <div key={index} className="bg-rose-50 p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-rose-600 mb-3">{account.bank} { account.favorite ? <FaStar className="inline-block ml-1" /> : undefined }</h3>
              <div className="space-y-2">
                <p>{ account.isBank ? 'Nombre: ' : '' }<span className="font-medium">{account.name}</span></p>
                <div className="flex justify-between items-center">
                  <p>{ account.isBank ? 'No. de cuenta: ' : '' } <span className="font-medium">{account.number}</span></p>
                  {
                    account.isBank ?
                  <button
                    onClick={() => copyToClipboard(account.bankCode)}
                    className="text-rose-600 hover:text-rose-700 flex items-center gap-1 text-sm cursor-pointer"
                  >
                      { account.isBank ? <FaCopy />  : ''}
                      { account.isBank ? (loadingIban ? <Bars
                        height="30"
                        width="30"
                        color="#BE123C"
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperClass="ml-3"
                        visible={true}
                        /> : ' Copiar')  : ''}
                  </button>
                  : <></>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Success notification */}
      {showCopiedMessage && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-fade-in z-50">
          <FaCheck />
          <span>¡IBAN copiado correctamente!</span>
        </div>
      )}
      
      {/* Error notification */}
      {showCopiedErrorMessage && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-fade-in z-50">
          <FaCheck />
          <span>¡Ha habido un error copiando el IBAN!. Vuelve a intentarlo más tarde. Sí el problema persiste ¡ponte en contacto con Dani o Raquel!</span>
        </div>
      )}
    </section>
  );
};

export default Gift;